import { IFormatterProps } from '../../../@types/workspaceTypes';
import React from 'react';

const GenericListFormatter = (formatterProps: IFormatterProps) => {
  const column = formatterProps.column;
  const rowData = formatterProps.dependentValues.rowData;
  const pathSegments = column.key.split('.');

  // Get the array from the first segment
  const arrayData = rowData[pathSegments[0]];

  // If no array or empty, return empty
  if (!Array.isArray(arrayData) || arrayData.length === 0) {
    return <></>;
  }

  // Get the remaining path segments after the array
  const remainingPath = pathSegments.slice(1);

  // Extract values from each array item following the path
  const values = arrayData
    .map((item) => {
      let current = item;

      // Traverse the remaining path
      for (const segment of remainingPath) {
        if (current && typeof current === 'object' && segment in current) {
          current = current[segment];
        } else {
          return null;
        }
      }

      return current;
    })
    .filter((value) => value !== null); // Remove null/undefined values

  // Join into comma-delimited string
  const result = values.join(', ');

  return <>{result}</>;
};

export default GenericListFormatter;
